const initState = {
  deleteUser: null,
  deleteParam: null,
  deleteUserCompleted: null,
  deleteParamCompleted: null,
  reauthenticateUserComp: null,
  reauthenticateError: null,
  reauthenticateFaceComp: null
};

const deleteReducer = (state = initState, action) => {
  switch (action.type) {
    case "DELETE_PARAM_SUCCESS":
      return {
        ...state,
        deleteParamCompleted: true
      };
    case "DELETE_PARAM_ERROR":
      return {
        ...state,
        deleteParam: action.err
      };
    case "DELETE_USER_SUCCESS":
      return {
        ...state,
        deleteUserCompleted: true
      };
    case "DELETE_USER_ERROR":
      return {
        ...state,
        deleteUser: action.error,
        deleteUserCompleted: false
      };
    case "RESET_DELETE_VARS":
      return {
        ...state,
        deleteParamCompleted: null,
        deleteUserCompleted: null,
        reauthenticateUserComp: null,
        reauthenticateError: null,
        reauthenticateFaceComp: null,
        deleteUser: null,
        deleteParam: null
      };
    case "REAUTHENTICATE_SUCCESS":
      return {
        ...state,
        reauthenticateUserComp: true
      };
    case "REAUTHENTICATE_ERROR":
      return {
        ...state,
        reauthenticateError: action.error
      };
    case "REAUTHENTICATE_FACE_SUCCESS":
      return {
        ...state,
        reauthenticateFaceComp: true
      };
    case "REAUTHENTICATE_FACE_ERR":
      return {
        ...state,
        reauthenticateFaceComp: false
      };
    default:
      return state;
  }
};

export default deleteReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/deleteReducer.tsx